import apiFetch from '../apiFetch'
export default function (dossierId, token, includeDeleted = false) {
  const queryParamsArray = [
    dossierId ? `dossierId=${dossierId}` : null,
    `includeDeleted=${includeDeleted}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: 'saleType' + queryParams, method: 'GET', body: null, token: token })
}
